import {QueryDomain} from "common/types/query_domain";
import {QuestionComplexity} from "../types";

export default function matchQuestionComplexity(
  queryDomain: QueryDomain,
  questionComplexities: QuestionComplexity[],
): string | null {
  const result =
    questionComplexities.find(qComplexity =>
      Object.entries(qComplexity.value).every(
        ([key, value]) => queryDomain.question_complexity[key] === value,
      ),
    )?.key ?? null;
  return result;
}
